(() => {
  const initTrainingSystem = (root) => {
    const copies = Array.from(root.querySelectorAll('[data-pilates-training-system-copy]'));
    const mediaSets = Array.from(root.querySelectorAll('[data-pilates-training-system-media]'));
    const prevBtn = root.querySelector('[data-pilates-training-system-prev]');
    const nextBtn = root.querySelector('[data-pilates-training-system-next]');

    if (copies.length === 0) return;

    let activeIndex = copies.findIndex((copy) => copy.classList.contains('is-active'));
    if (activeIndex < 0) activeIndex = 0;

    const setActive = (index) => {
      const count = copies.length;
      activeIndex = (index + count) % count;

      copies.forEach((copy, i) => {
        const isActive = i === activeIndex;
        copy.classList.toggle('is-active', isActive);
        copy.setAttribute('aria-hidden', isActive ? 'false' : 'true');
      });

      mediaSets.forEach((media, i) => {
        const isActive = i === activeIndex;
        media.classList.toggle('is-active', isActive);
        media.setAttribute('aria-hidden', isActive ? 'false' : 'true');
      });
    };

    const learnMoreBtn = root.querySelector('.pilates-training-system__link[href]');
    learnMoreBtn?.addEventListener('click', () => {
      if (window.PilatesAnalytics && typeof window.PilatesAnalytics.pushLearnMore === 'function') {
        window.PilatesAnalytics.pushLearnMore({
          itemName: learnMoreBtn.textContent.trim(),
          section: 'section_training_system',
        });
      }
    });

    const pushArrowClick = (direction) => {
      if (!window.PilatesAnalytics || typeof window.PilatesAnalytics.pushLearnMore !== 'function') return;
      const activeCopy = copies[activeIndex];
      const titleEl = activeCopy?.querySelector('.pilates-training-system__title');
      const params = {
        itemName: titleEl ? titleEl.textContent.trim() : '',
        section: `section_training_system_${direction}`,
      };
      window.PilatesAnalytics.pushLearnMore(params);
    };

    prevBtn?.addEventListener('click', () => {
      setActive(activeIndex - 1);
      pushArrowClick('prev');
    });
    nextBtn?.addEventListener('click', () => {
      setActive(activeIndex + 1);
      pushArrowClick('next');
    });

    setActive(activeIndex);
  };

  document.querySelectorAll('[data-pilates-training-system]').forEach(initTrainingSystem);
})();
